export default [
  {
    width: 50,
    header: {
      type: 'text',
      caption: 'Currency',
    },
    cell: {
      type: 'text',
      value: (e) => e.fiatCurrencyTitle,
    },
  },
  {
    width: 50,
    header: {
      type: 'text',
      caption: 'Denomination',
    },
    cell: {
      type: 'slot',
      name: 'denomination',
    },
  },
  {
    width: 50,
    header: {
      type: 'text',
      caption: 'Quantity',
    },
    cell: {
      type: 'slot',
      name: 'quantity',
    },
  },
];
